import React from 'react';
import { Star, StarHalf } from 'lucide-react';

const Stars = ({ rating = 5, size = 14, color = '#D9A441' }) => {
  const full = Math.floor(rating);
  const half = rating - full >= 0.5;
  const empty = 5 - full - (half ? 1 : 0);
  return (
    <div className="inline-flex items-center gap-[2px]">
      {Array.from({ length: full }).map((_, i) => (
        <Star key={`f${i}`} size={size} fill={color} color={color} strokeWidth={0} />
      ))}
      {half && <StarHalf size={size} fill={color} color={color} strokeWidth={0} />}
      {Array.from({ length: empty }).map((_, i) => (
        <Star key={`e${i}`} size={size} color={color} fill="transparent" strokeWidth={1.5} />
      ))}
    </div>
  );
};

export default Stars;
